<div class="margin-top-2">
  <form id="userPreferencesBodyForm" role="form" [formGroup]="userPreferencesBodyForm">
    <fieldset class="usa-fieldset">
      <div class="padding-y-05">
        <span class="usa-checkbox define-background-checkbox">
          <input class="usa-checkbox__input" id="select-all" type="checkbox" [checked]="selectAll"
            (change)="onSelectAll($event.target.checked)"/>
          <label class="usa-checkbox__label" for="select-all">Select All</label>
        </span>
      </div>
      <div class="grid-row grid-gap-1">
        @for (pref of userPrefList; track pref; let i = $index) {
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3 padding-y-05"
            >
            <span class="usa-checkbox define-background-checkbox">
              <input class="usa-checkbox__input" id={{i}} type="checkbox" [checked]="pref.isVisible"
                (change)="onCheckboxChange(pref.headerName,$event.target.checked)"/>
              <label class="usa-checkbox__label" for={{i}}>{{pref.headerName}}</label>
            </span>
          </div>
        }
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 margin-top-2">
        <button type="button" class="usa-button usa-button--outline" (click)="savePref()">Save preferences</button>
      </div>
    </fieldset>
  </form>
</div>
